/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GuestPersonalInfoDto
 */
export interface GuestPersonalInfoDto {
    /**
     * 
     * @type {string}
     * @memberof GuestPersonalInfoDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof GuestPersonalInfoDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof GuestPersonalInfoDto
     */
    middleName: string;
    /**
     * 
     * @type {string}
     * @memberof GuestPersonalInfoDto
     */
    citizenship: string;
}

/**
 * Check if a given object implements the GuestPersonalInfoDto interface.
 */
export function instanceOfGuestPersonalInfoDto(value: object): value is GuestPersonalInfoDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('middleName' in value) || value['middleName'] === undefined) return false;
    if (!('citizenship' in value) || value['citizenship'] === undefined) return false;
    return true;
}

export function GuestPersonalInfoDtoFromJSON(json: any): GuestPersonalInfoDto {
    return GuestPersonalInfoDtoFromJSONTyped(json, false);
}

export function GuestPersonalInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuestPersonalInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'],
        'citizenship': json['citizenship'],
    };
}

  export function GuestPersonalInfoDtoToJSON(json: any): GuestPersonalInfoDto {
      return GuestPersonalInfoDtoToJSONTyped(json, false);
  }

  export function GuestPersonalInfoDtoToJSONTyped(value?: GuestPersonalInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'middleName': value['middleName'],
        'citizenship': value['citizenship'],
    };
}

